import axios from "axios";
import { baseAddress } from "../../tools/baseAddress";
import { ENDPOINTS } from "../../tools/endpoints";

let address = baseAddress + ENDPOINTS.INPUTS_DATA;
let addressGraphicGenerator = baseAddress + ENDPOINTS.GRAPHIC_GENERATOR;

export const getInputData = () => {
  return axios
    .post(address, {
      token: localStorage.getItem("token")
    })
    .then(response => {
      return response;
    })
    .catch(err => {
      console.error(err);
    });
};

export const getGraph = (txt, systemName, distortionType, axis_type) => {
  var formData = new FormData();
  formData.append("txtfile", txt);
  formData.append("system_name", systemName);
  formData.append("distortion_type", distortionType);
  formData.append("token", localStorage.getItem("token"));
  if (distortionType !== undefined) {
    formData.append("axis_type", axis_type);
  }
  
  return axios
    .post(addressGraphicGenerator, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      return err.response;
    });
};